export const VoteType = {
	like: 'like',
	dislike: 'dislike',
	none: 'none',
};
